<template>
  <v-container style="height:100vh">
    <v-row align="center" class="fill-height">
      <v-col>
        <v-row
          align="center"
          justify="center"
          class="py-5"
          id="card"
          data-aos="fade-right"
        >
          <div id="inner-card" ref="card"></div>
          <v-col cols="12" md="6">
            <v-img
              :src="require(`@/assets/${img}`)"
              contain
              data-aos="fade-left"
              max-width="100vw"
            ></v-img>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="5">
            <h1 v-html="title"></h1>
            <p>{{ text }}</p>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn color="white" v-if="btn" tile :to="{ name: to }">{{
                  btn
                }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    bgcolor: String,
    img: String,
    title: String,
    text: String,
    btn: String,
    to: String
  },
  mounted() {
    this.$refs.card.style.backgroundColor = this.bgcolor;
  }
};
</script>

<style lang="scss" scoped>
#card {
  position: relative;
  * {
    z-index: 1;
  }
  #inner-card {
    @media (min-width: 992px) {
      display: block;
      width: 75%;
    }
    @media (min-width: 1200px) {
      width: 100%;
    }
    display: none;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    z-index: 0;
    position: absolute;
    left: 30%;
    width: 100%;
    height: 120%;
  }
}
</style>
